export default __webpack_public_path__ + "static/media/barra.28e3a92f.png";